(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (() => {

      if (window.__neelamCollectionControlsBound) return;

      window.__neelamCollectionControlsBound = true;



      document.addEventListener('click', (event) => {

        const openButton = event.target.closest('[data-na-sort-open]');

        if (openButton) {

          const sheet = document.getElementById(openButton.dataset.naSortOpen);

          if (sheet && !sheet.open) sheet.showModal();

          return;

        }



        const closeButton = event.target.closest('[data-na-sort-close]');

        if (closeButton) closeButton.closest('dialog')?.close();

      });



      document.addEventListener('change', (event) => {

        const sortInput = event.target.closest('[data-na-mobile-sort]');

        if (!sortInput) return;



        const url = new URL(window.location.href);

        url.searchParams.set('sort_by', sortInput.value);

        url.searchParams.delete('page');

        window.location.assign(url.toString());

      });

    })();
  } catch(e) { console.error(e); }
})();

})();
